import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, MapPin, Clock, ArrowRight, MessageSquare, Building2, HelpCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Badge } from '../components/ui/Badge';
export function ContactPage() {
  return <div className="min-h-screen bg-cream-50 pt-20 pb-24" data-id="element-251">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-forest-900 via-forest-800 to-forest-950 text-white overflow-hidden py-20 mb-16" data-id="element-252">
        <div className="absolute inset-0 bg-mesh opacity-30" data-id="element-253"></div>
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-ember-500/20 rounded-full blur-3xl" data-id="element-254"></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-255">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-256">
            <Badge variant="gradient" className="mb-6" data-id="element-257">
              <MessageSquare className="w-3 h-3 mr-1" data-id="element-258" /> Get in Touch
            </Badge>
            <h1 className="text-4xl md:text-6xl font-display font-bold mb-6" data-id="element-259">
              We're Here to <span className="text-ember-400" data-id="element-260">Help</span>
            </h1>
            <p className="text-xl text-forest-100 max-w-2xl mx-auto leading-relaxed" data-id="element-261">
              Whether you have a question about our courses, need corporate
              training, or require technical support, our team is ready to
              assist you.
            </p>
          </motion.div>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-262">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12" data-id="element-263">
          {/* Contact Form */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="lg:col-span-8 bg-white rounded-3xl p-8 md:p-12 shadow-2xl border-2 border-forest-50" data-id="element-264">
            <h2 className="text-3xl font-display font-bold text-forest-900 mb-8" data-id="element-265">
              Send us a message
            </h2>

            <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-266">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-267">
                <div className="space-y-2" data-id="element-268">
                  <label htmlFor="firstName" className="block text-sm font-bold text-forest-900" data-id="element-269">
                    First Name
                  </label>
                  <input type="text" id="firstName" className="w-full px-4 py-3 rounded-xl border-2 border-forest-100 focus:border-forest-500 focus:ring-0 transition-colors bg-forest-50/30" placeholder="John" data-id="element-270" />
                </div>
                <div className="space-y-2" data-id="element-271">
                  <label htmlFor="lastName" className="block text-sm font-bold text-forest-900" data-id="element-272">
                    Last Name
                  </label>
                  <input type="text" id="lastName" className="w-full px-4 py-3 rounded-xl border-2 border-forest-100 focus:border-forest-500 focus:ring-0 transition-colors bg-forest-50/30" placeholder="Doe" data-id="element-273" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-274">
                <div className="space-y-2" data-id="element-275">
                  <label htmlFor="email" className="block text-sm font-bold text-forest-900" data-id="element-276">
                    Email Address
                  </label>
                  <input type="email" id="email" className="w-full px-4 py-3 rounded-xl border-2 border-forest-100 focus:border-forest-500 focus:ring-0 transition-colors bg-forest-50/30" placeholder="john@example.com" data-id="element-277" />
                </div>
                <div className="space-y-2" data-id="element-278">
                  <label htmlFor="phone" className="block text-sm font-bold text-forest-900" data-id="element-279">
                    Phone Number
                  </label>
                  <input type="tel" id="phone" className="w-full px-4 py-3 rounded-xl border-2 border-forest-100 focus:border-forest-500 focus:ring-0 transition-colors bg-forest-50/30" placeholder="08X XXX XXXX" data-id="element-280" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-281">
                <div className="space-y-2" data-id="element-282">
                  <label htmlFor="company" className="block text-sm font-bold text-forest-900" data-id="element-283">
                    Company Name (Optional)
                  </label>
                  <input type="text" id="company" className="w-full px-4 py-3 rounded-xl border-2 border-forest-100 focus:border-forest-500 focus:ring-0 transition-colors bg-forest-50/30" placeholder="Your Company Ltd" data-id="element-284" />
                </div>
                <div className="space-y-2" data-id="element-285">
                  <label htmlFor="enquiryType" className="block text-sm font-bold text-forest-900" data-id="element-286">
                    Enquiry Type
                  </label>
                  <select id="enquiryType" className="w-full px-4 py-3 rounded-xl border-2 border-forest-100 focus:border-forest-500 focus:ring-0 transition-colors bg-forest-50/30 text-gray-700" data-id="element-287">
                    <option data-id="element-288">General Enquiry</option>
                    <option data-id="element-289">Course Enquiry</option>
                    <option data-id="element-290">Corporate Training</option>
                    <option data-id="element-291">Technical Support</option>
                  </select>
                </div>
              </div>

              <div className="space-y-2" data-id="element-292">
                <label htmlFor="message" className="block text-sm font-bold text-forest-900" data-id="element-293">
                  Message
                </label>
                <textarea id="message" rows={5} className="w-full px-4 py-3 rounded-xl border-2 border-forest-100 focus:border-forest-500 focus:ring-0 transition-colors bg-forest-50/30 resize-none" placeholder="How can we help you?" data-id="element-294"></textarea>
              </div>

              <Button type="submit" size="lg" variant="primary" className="w-full md:w-auto" data-id="element-295">
                Send Message <ArrowRight className="w-4 h-4 ml-2" data-id="element-296" />
              </Button>
            </form>
          </motion.div>

          {/* Sidebar */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="lg:col-span-4 space-y-6" data-id="element-297">
            {/* Contact Info Card */}
            <div className="bg-gradient-to-br from-forest-900 to-forest-800 rounded-3xl p-8 text-white shadow-xl relative overflow-hidden" data-id="element-298">
              <div className="absolute top-0 right-0 w-32 h-32 bg-ember-500/20 rounded-full blur-2xl" data-id="element-299"></div>
              <h3 className="text-2xl font-display font-bold mb-8 relative z-10" data-id="element-300">
                Contact Information
              </h3>

              <div className="space-y-6 relative z-10" data-id="element-301">
                <div className="flex items-start" data-id="element-302">
                  <div className="w-10 h-10 bg-white/10 rounded-xl flex items-center justify-center mr-4 shrink-0" data-id="element-303">
                    <Phone className="w-5 h-5 text-ember-400" data-id="element-304" />
                  </div>
                  <div data-id="element-305">
                    <p className="text-sm text-forest-200 mb-1" data-id="element-306">Phone</p>
                    <p className="font-bold" data-id="element-307">01 456 7890</p>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-308">
                  <div className="w-10 h-10 bg-white/10 rounded-xl flex items-center justify-center mr-4 shrink-0" data-id="element-309">
                    <Mail className="w-5 h-5 text-ember-400" data-id="element-310" />
                  </div>
                  <div data-id="element-311">
                    <p className="text-sm text-forest-200 mb-1" data-id="element-312">Email</p>
                    <p className="font-bold" data-id="element-313">info@foodsafeireland.ie</p>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-314">
                  <div className="w-10 h-10 bg-white/10 rounded-xl flex items-center justify-center mr-4 shrink-0" data-id="element-315">
                    <MapPin className="w-5 h-5 text-ember-400" data-id="element-316" />
                  </div>
                  <div data-id="element-317">
                    <p className="text-sm text-forest-200 mb-1" data-id="element-318">Address</p>
                    <p className="font-bold leading-relaxed" data-id="element-319">
                      Unit 4, Park West Business Park,
                      <br data-id="element-320" />
                      Dublin 12, Ireland
                    </p>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-321">
                  <div className="w-10 h-10 bg-white/10 rounded-xl flex items-center justify-center mr-4 shrink-0" data-id="element-322">
                    <Clock className="w-5 h-5 text-ember-400" data-id="element-323" />
                  </div>
                  <div data-id="element-324">
                    <p className="text-sm text-forest-200 mb-1" data-id="element-325">
                      Opening Hours
                    </p>
                    <p className="font-bold" data-id="element-326">Mon-Fri: 9:00 AM - 5:00 PM</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div className="bg-white rounded-3xl p-8 border-2 border-forest-100 shadow-lg" data-id="element-327">
              <h3 className="text-xl font-display font-bold text-forest-900 mb-6" data-id="element-328">
                Quick Links
              </h3>
              <div className="space-y-4" data-id="element-329">
                <Link to="/help" className="flex items-center p-4 rounded-xl bg-forest-50 hover:bg-ember-50 border border-forest-100 hover:border-ember-200 transition-colors group" data-id="element-330">
                  <HelpCircle className="w-6 h-6 text-forest-600 group-hover:text-ember-500 mr-3 transition-colors" data-id="element-331" />
                  <div data-id="element-332">
                    <p className="font-bold text-forest-900 group-hover:text-ember-700 transition-colors" data-id="element-333">
                      Looking for help?
                    </p>
                    <p className="text-xs text-gray-500" data-id="element-334">
                      Visit our Help Centre
                    </p>
                  </div>
                </Link>

                <Link to="/corporate" className="flex items-center p-4 rounded-xl bg-forest-50 hover:bg-ember-50 border border-forest-100 hover:border-ember-200 transition-colors group" data-id="element-335">
                  <Building2 className="w-6 h-6 text-forest-600 group-hover:text-ember-500 mr-3 transition-colors" data-id="element-336" />
                  <div data-id="element-337">
                    <p className="font-bold text-forest-900 group-hover:text-ember-700 transition-colors" data-id="element-338">
                      Corporate Enquiry?
                    </p>
                    <p className="text-xs text-gray-500" data-id="element-339">
                      View team training options
                    </p>
                  </div>
                </Link>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>;
}